import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthStore } from '../auth';
import { getLoginRedirectQuery } from '../auth/auth.flow';
import { APP_CONFIG } from '../config';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const config = inject(APP_CONFIG);

  return next(
    req.clone({
      withCredentials: true
    })
  ).pipe(
    catchError((error: unknown) => {
      const isSessionExpired =
        error instanceof HttpErrorResponse &&
        error.status === 401 &&
        req.url.startsWith(config.apiBaseUrl) &&
        authStore.isAuthenticated() &&
        router.url !== '/login';

      if (isSessionExpired) {
        authStore.setUnauthenticated();
        void router.navigate(['/login'], { queryParams: getLoginRedirectQuery(router.url) });
      }

      return throwError(() => error);
    })
  );
};
